<template>
  <div
    class="select-none transform transition-all duration-600 h-10 text-white rounded-md flex items-center text-sm">
      <slot name="commons" />
      <div class="hidden md:block">
        <slot name="desktop" />
      </div>
      <div
        ref="moreSection"
        class="relative">
        <base-button
          @click="toggleMore"
          :loading="isGeneralLoading" 
          :disabled="isGeneralLoading"
          :aria-expanded="more.toString()"
          mode="secondary"
          :ariaLabel="$t('components.baseTableSelectActionsForm.ariaLabel', { name, action: more ? $t('components.baseTableSelectActionsForm.collapseActions') : $t('components.baseTableSelectActionsForm.expandActions') })">
          <!-- <base-icon name="more"/> -->
          <span class="count font-bold whitespace-nowrap w-full text-center"> {{ name }}</span>
          <base-icon v-if="baseDropDownVisible" 
            :class="{'transform rotate-180':more}"
            class="transition-transform duration-300 ml-2"
            name="chevronup"
            :ariaHidden="true"/>
        </base-button>
        <base-drop-down v-if="baseDropDownVisible" 
          autoClose=true 
          :closeWithEscape="false"
          :isOpen="more" 
          :position="isLower1024 ? 'bottom-right-75' : 'bottom-right'" 
          customClass="w-72 p-1 bg-secondary-800 bottom-10" 
          @toggle="closeMore" >
          <slot name="more" />
        </base-drop-down>
      </div>
    </div>
</template>

<script>
export default {
  name: 'base-table-select-actions-form',
  props: {
    name: {
      type: String,
      default: 'Acciones'
    },
    baseDropDownVisible: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      more: false,
      core: false
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
  },
  methods: {
    toggleMore: function () {
      this.more = !this.more
    },
    toggleCore: function () {
      this.core = !this.core
    },
    closeMore: function () {
      this.more = false
    },
    closeCore: function () {
      this.core = false
    }
  }
}
</script>
